<div class="w-[1200px] flex flex-col gap-y-4">
  <h2 class="font-semibold text-lg">{{ title$ | async }}</h2>

  <div class="flex gap-x-2">
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="packageTypeForm.controls.code"
      >Код</tui-input
    >
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="packageTypeForm.controls.name"
      >Наименование</tui-input
    >
    <tui-input
      class="w-2/12"
      tuiTextfieldSize="m"
      [formControl]="packageTypeForm.controls.size"
      >Размер</tui-input
    >
    <tui-input-number
      class="w-2/12"
      tuiTextfieldSize="m"
      [formControl]="packageTypeForm.controls.weight"
      >Вес (кг)</tui-input-number
    >
  </div>
  <div class="w-full">
    <tui-input-tag
      [separator]="';'"
      [tuiTextfieldLabelOutside]="true"
      [tuiTextfieldCleaner]="true"
      [autoColor]="true"
      tuiTextfieldSize="m"
      [formControl]="packageTypeForm.controls.tags"
    >
      <span>Теги</span></tui-input-tag
    >
  </div>

  <div class="max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      cargoPlaceQuantity of packageTypeForm.controls.cargoPlaceQuantityJson
        .controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <div class="flex gap-x-2 items-center mb-2">
        <app-autocomplete
          class="w-5/12"
          [items]="cargoPlaces$ | async"
          [itemValue]="'id'"
          [itemText]="'text'"
          [displayValue]="'text'"
          [formControl]="cargoPlaceQuantity.controls.cargoPlaceId"
          >Грузое место</app-autocomplete
        >
        <tui-input-number
          [precision]="0"
          class="w-5/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="cargoPlaceQuantity.controls.quantity"
          >Количество</tui-input-number
        >
        <div class="flex gap-x-2 w-1/12 items-center">
          <button
            appearance="accent"
            size="s"
            (click)="removeCargoPlaceQuantity(index)"
            tuiIconButton
            icon="tuiIconTrash"
          ></button>
          @if (last) {
            <button
              tuiIconButton
              size="s"
              (click)="addCargoPlaceQuantity()"
              icon="tuiIconPlus"
            ></button>
          }
        </div>
      </div>
    } @empty {
      <button
        size="s"
        tuiButton
        icon="tuiIconPlus"
        (click)="addCargoPlaceQuantity()"
      >
        Добавить кол-во для грузового места
      </button>
    }
  </div>
  <div class="flex justify-end">
    <button
      (click)="context.$implicit.complete()"
      size="m"
      appearance="outline"
      tuiButton
      class="mr-2"
    >
      Отмена
    </button>
    <button
      (click)="save$.next()"
      [disabled]="!packageTypeForm.valid"
      tuiButton
      size="m"
    >
      Сохранить
    </button>
  </div>
</div>
